import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import HorizontalPanel from "../../../components/HorizontalPanel";
import { Toolbar } from "../../../app/components";
import DeviceMenuList from "../../DeviceMenuList";
import { pagePathGenerator } from "../../../routes/pagePathGenerator";
import { selectCurrentMap } from "../../../store/mapStore/mapSelectors";
import { setEditMode } from "../../../store/generalStore/generalState";
import { useTypedDispatch } from "../../../app/state";
import { selectCurrentDevice, selectDevicesByMapId } from "../../../store/deviceStore/deviceSelectors";
import DeviceSummary from "../DeviceSummary";
import { IconButton } from "@material-ui/core";
import TransitEnterexitIcon from "@material-ui/icons/TransitEnterexit";
import useFilter from "../../../hooks/filter.hook";
import FilterPanel from "../../Shared/FilterPanel";
import { getAllWirelessSystems } from "../../../store/wirelessSystemStore/wirelessSystemRequests";
import {
  requestAllTechnologyConfigurations
} from "../../../store/technologyConfigurationStore/technologyConfigurationRequests";
import { GeneralRequest } from "../../../requests/GeneralRequest";
import { setDrawingStatus } from "../../../store/drawingStore/drawingState";
import CoverageSettings from "../../Shared/CoverageSettings";
import { selectLocationIndoorDeviceList } from "../../../store/mapDeviceStore/mapDeviceSelectors";
import useDevicesPage from "../../DevicesPage/devicePageHooks";
import FrequencyAnalysisLinkIcon from "../../FrequencyAnalysisPage/FrequencyAnalysisLinkIcon";

const DeviceMapLeftPanel = () => {
  const dispatch = useTypedDispatch();
  const history = useHistory();
  const filters = useFilter();
  const devicePage = useDevicesPage();
  const { currentMapId } = devicePage.state;
  const currentPlaceDevices = useSelector(selectDevicesByMapId(currentMapId));
  const {
    isAnyFilterChosen,
    isManualFiltersPanelVisible,
    isCoveragePanelVisible,
    showIndoorDeviceList,
  } = filters.state;
  const currentMap = useSelector(selectCurrentMap);
  const currentDevice = useSelector(selectCurrentDevice);
  const indoorDeviceList = useSelector(selectLocationIndoorDeviceList(currentMap));
  const totalDeviceList = showIndoorDeviceList ? [ ...currentPlaceDevices, ...indoorDeviceList ] : currentPlaceDevices;
  const filteredTotalDeviceList = filters.actions.filterDeviceList(totalDeviceList);
  const filteredTotalDeviceIdList = filteredTotalDeviceList.map((device) => device.id);

  const isDeviceSelected = !!currentDevice;

  const selectDevice = (id: number | null) => {
    dispatch(setEditMode(false));
    const url = pagePathGenerator.DEVICES_MAP({
      mapId: currentMapId,
      deviceId: id,
    });

    history.replace(url);
  }

  const onBackClick = () => {
    selectDevice(null);

    // clear drawing
    dispatch(setEditMode(false));
    dispatch(setDrawingStatus(false));
  }

  if (isManualFiltersPanelVisible) {
    return (
      <GeneralRequest requestAction={getAllWirelessSystems}>
        <GeneralRequest requestAction={requestAllTechnologyConfigurations}>
          <FilterPanel onSelectedDeviceClear={onBackClick} />
        </GeneralRequest>
      </GeneralRequest>
    )
  }

  if (isCoveragePanelVisible) {
    return <CoverageSettings />
  }

  if (isDeviceSelected) {
    return (
      <HorizontalPanel size={HorizontalPanel.SIZES.WHOLE_SPACE}>
        <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
          <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
            <Toolbar title="Device summary">
              <IconButton
                aria-label='close window'
                color='secondary'
                size='small'
                onClick={onBackClick}
              >
                <TransitEnterexitIcon />
              </IconButton>
            </Toolbar>
          </HorizontalPanel>
          <HorizontalPanel size={HorizontalPanel.SIZES.REST_SPACE} addScroll>
            <DeviceSummary />
          </HorizontalPanel>
        </HorizontalPanel>
      </HorizontalPanel>
    )
  }

  return (
    <HorizontalPanel size={HorizontalPanel.SIZES.WHOLE_SPACE}>
      <HorizontalPanel size={HorizontalPanel.SIZES.WHOLE_SPACE}>
        <HorizontalPanel size={HorizontalPanel.SIZES.SMALL}>
          <Toolbar title={isAnyFilterChosen ? "Filtered Device List" : "Device list"}>
            <FrequencyAnalysisLinkIcon
              deviceIdList={filteredTotalDeviceIdList}
            />
          </Toolbar>
        </HorizontalPanel>
        <HorizontalPanel size={HorizontalPanel.SIZES.REST_SPACE} addScroll>
          <DeviceMenuList
            deviceList={filteredTotalDeviceList}
            showFiltered={false}
            onDeviceClick={selectDevice}
          />
        </HorizontalPanel>
      </HorizontalPanel>
    </HorizontalPanel>
  );
};

export default DeviceMapLeftPanel;